import React, { useEffect, useState } from "react";

function InvestorField({ label, value }) {
  return (
    <div className="grid">
      <label>{label}</label>
      <div>{value || "--"}</div>
    </div>
  );
}

export default function InvestorView(props) {
  const [investor, setInvestor] = useState(null);
  const excludedFields = ["investorID"];

  useEffect(() => {
    setInvestor(props.investor);
  }, [props]);

  const tansformKey = (key) => {
    if (key.includes("_")) {
      if (key === "no_sectors") {
        return "No go sector";
      }
      return key.replace(/_/g, " ");
    }
    return key;
  };

  const tansformValue = (value) => {
    if (Array.isArray(value)) {
      return value.join(", ");
    }
    return value;
  };

  return (
    <div className="investorview container">
      {investor ? (
        <>
          {Object.keys(investor).map((key) => {
            if (!excludedFields.includes(key)) {
              const investorValue = investor[key];
              return (
                <InvestorField
                  label={tansformKey(key)}
                  value={tansformValue(investorValue)}
                />
              );
            }
          })}
        </>
      ) : null}
      <p>
        <b>
          Note: If you like to update/edit details, please contact at{" "}
          <a href="mailto:vk@venturegarage.in">vk@venturegarage.in</a> or
          whatsapp at <a href="tel:8858049291">8858049291</a>
        </b>
      </p>
    </div>
  );
}
